/** Port of legacy DataStores cusipDiversifications idParser. */
export function encodeCusipForUrl(cusip: string): string {
  const withSlashes = cusip.replace(/\//g, '_sl_');
  const withAsterisks = withSlashes.replace(/\*/g, '_');
  return encodeURIComponent(withAsterisks);
}
